<template>
  <div class="col-span-12">
    <div class= " flex flex-col sm:flex-row col-span-12 lg:col-span-12 mt-8 flex rounded-xl p-2 sm:p-4 bg-white  lg:pb-4 xl:pb-0 " v-for="w in data">
      <div class="w-full sm:w-1/3 ">
        <img :src="'https://backend.upskillbangladesh.com/' + w.info.image" class=" w-full rounded-xl" alt="" style="object-fit: cover">
      </div>
      <div class="w-full  sm:w-2/3 bg-white px-2 sm:px-8 ">
        <h1 class="text-xs text-gray-500 uppercase tracking-tighter py-2 sm:py-0 lg:py-1">workshop </h1>
        <h1 class="text-xl text-blue-600 capitalize tracking-wider py-1 lg:text-2xl">{{w.info.name}} </h1>
        <p class="text-gray-400">
          {{ parseTime(w.info.time) }}
        </p>

        <div class="grid grid-cols-3 pt-4 sm:pt-8 ">
          <div>
            <p class="text-gray-500 uppercase font-bold">
              gross revenue
            </p>
            <h2 class="text-blue-800 text-2xl sm:text-3xl font-bold">
              BDT {{ w.info.amount }}
            </h2>
          </div>
          <div>
            <p class="text-gray-500 uppercase font-bold">
              discount applied
            </p>
            <h2 class="text-blue-800 text-2xl sm:text-3xl font-bold">
              BDT {{  parseInt(w.info.paid) * parseInt(w.info.fee) - parseInt(w.info.amount) }}
            </h2>
          </div>
          <div>
            <p class="text-gray-500 uppercase font-bold">
              your earning
            </p>
            <h2 class="text-blue-900 text-2xl sm:text-3xl font-bold">
              BDT {{ (w.info.amount - w.info.expense) * w.info.share  }}
            </h2>
          </div>
        </div>
              <button class="button w-48 mb-2 bg-green-600 text-white mr-4" @click="$router.push({name:'simple-menu-chat'})">
                Group Chat
              </button>
               <button
                class="button w-32 mr-1 mb-8 mt-2 border text-white bg-blue-700 "
                @click="$router.push({name:'registrants'})"
              >
                Registrants
              </button>
              <button
                  class="button w-32 mr-1 mb-8 mt-2 border text-white bg-blue-700 "
                  @click="$router.push({name:'registrants'})"
              >
                Zoom Link
              </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
export default {
  props: ["data"],
  methods: {
    parseTime(ts) {
      return moment(ts).format("LLL")
    }
  }
}
</script>
